var _path, _g, _path2, _g2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHours(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3397_2906",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 4,
    width: 9,
    height: 10
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5207 13.6233C13.9915 13.6233 15.9944 11.6204 15.9944 9.14956C15.9944 6.67871 13.9915 4.67578 11.5207 4.67578C9.0498 4.67578 7.04688 6.67871 7.04688 9.14956C7.04688 11.6204 9.0498 13.6233 11.5207 13.6233Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3397_2906)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5207 13.6233C13.9915 13.6233 15.9944 11.6204 15.9944 9.14956C15.9944 6.67871 13.9915 4.67578 11.5207 4.67578C9.0498 4.67578 7.04688 6.67871 7.04688 9.14956C7.04688 11.6204 9.0498 13.6233 11.5207 13.6233Z",
    fill: "#E85F3D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3397_2906",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.32559 15.1434C11.3713 15.1434 14.6512 11.8635 14.6512 7.81779C14.6512 3.77205 11.3713 0.492188 7.32559 0.492188C3.27986 0.492188 0 3.77205 0 7.81779C0 11.8635 3.27986 15.1434 7.32559 15.1434Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3397_2906)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.3256 15.1434C11.3713 15.1434 14.6512 11.8635 14.6512 7.81778C14.6512 3.77204 11.3713 0.492188 7.3256 0.492188C3.27963 0.492188 0 3.77204 0 7.81778C0 11.8635 3.27963 15.1434 7.3256 15.1434Z",
    fill: "url(#paint0_radial_3397_2906)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.14844 6.2854L7.32256 8.64982L11.6055 5.2793",
    stroke: "white",
    strokeWidth: 1.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3397_2906",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.3256 7.81779) rotate(90.9799) scale(13.506 13.4977)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE613F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479832,
    stopColor: "#F18E76",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F79580"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHours);
export default __webpack_public_path__ + "static/media/hours.4866a9b494fe9b49e38e5e90de56238d.svg";
export { ForwardRef as ReactComponent };